export default {
  CHANGE_LOADING (state, loading) {
    state.loading = loading
  }
}
